import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshSubscription = async () => {
    try {
      const { data } = await api.get("/subscription");
      setSubscription(data.subscription);
      return data.subscription;
    } catch {
      return null;
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("sc_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then(({ data }) => {
        setUser(data.user);
        setSubscription(data.subscription);
      })
      .catch(() => {
        localStorage.removeItem("sc_token");
      })
      .finally(() => setLoading(false));
  }, []);

  const applyAuth = async (data) => {
    localStorage.setItem("sc_token", data.token);
    setUser(data.user);
    await refreshSubscription();
  };

  const logout = () => {
    localStorage.removeItem("sc_token");
    setUser(null);
    setSubscription(null);
  };

  return (
    <AuthContext.Provider value={{ user, subscription, loading, applyAuth, logout, refreshSubscription }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
